module.exports = ".mat-column-select {\n    overflow: visible;\n}\n\n.example-header {\n    min-height: 64px;\n    padding: 8px 24px 0;\n}\n\n.mat-form-field {\n    font-size: 14px;\n    width: 100%;\n}\n\n.mat-table {\n    overflow: auto;\n    max-height: 500px;\n}\n\n.primary {\n    background-color: #F5477F;\n    color: white;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/reports/reports.component.css
// module id = ./src/app/reports/reports.component.css
// module chunks = main